import { useAuth } from '@features/auth/hooks/useAuth';
import { Navigate } from 'react-router-dom';
import { ReactNode } from 'react';

interface PrivatePageProps {
  children: ReactNode;
}

export function PrivatePage({ children }: PrivatePageProps) {
  const { data } = useAuth();

  if (!data.accessToken) {
    return <Navigate to="/auth" />;
  }

  return children;
}
